module.exports = __webpack_public_path__ + "media/entities/1143-d2ae6a3a.png";